import React, { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { TimeSlotStructureLabels, TimeSlotStructureType } from "../../model/TimeSlotStructure";
import { GetTranslation } from "../../translations/GetTranslation";
import { CustomAutocomplete } from "../common/customAutocomplete/CustomAutocomplete";
import { IOption } from "../common/customAutocomplete/IOption";

interface TimeSlotStructureSelectProps {
  value: TimeSlotStructureType;
  onChange?: (value: TimeSlotStructureType) => void;
  error?: boolean;
}

export const TimeSlotStructureSelect: FC<TimeSlotStructureSelectProps> = ({
  value,
  onChange = (_value: TimeSlotStructureType) => {},
  error,
}) => {
  const intl = useIntl();
  const [options, setOptions] = useState<IOption<TimeSlotStructureType>[]>([]);

  useEffect(() => {
    const structureOptions = Object.values(TimeSlotStructureType).map((structureValue) => {
      return { value: structureValue, label: GetTranslation(intl, TimeSlotStructureLabels[structureValue]) };
    });
    setOptions(structureOptions);
  }, [intl]);

  const selectedValue = options.find((structure) => structure.value === value) || null;
  return (
    <CustomAutocomplete
      xs={12}
      sm={6}
      md={6}
      disableClearable={options.length > 0}
      label={GetTranslation(intl, "examDay.field.timeSlotStructure")}
      options={options}
      getOptionLabel={(option) => option.label}
      value={selectedValue}
      onChange={(_event, value) => onChange(value?.value || options[0].value)}
      required={true}
      error={error}
    />
  );
};
